import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { TextView } from 'src/core/ui/text.view';

interface ClientContactViewProps extends ComponentViewProps<ClientItem> {
	mode: ControlMode;
}

@observer
export class ClientContactView extends React.Component<ClientContactViewProps, any> {
	public constructor(props) {
		super(props);
	}

	public render() {
		const model = this.props.model;
		return (
			<div>
				<Row>
					<Col sm={24}>
						<TextView label='Email'
							value={model.dynamicProperties.email} mode={this.props.mode}
							onGetErrorMessage={() => this.props.model.validate(false, 'email')}
							onChanged={newVal => model.dynamicProperties.email = newVal} />
					</Col>
					<Col sm={24}>
						<TextView label='Mobile phone'
							onGetErrorMessage={() => this.props.model.validate(false, 'mobilePhone')}
							value={model.dynamicProperties.mobilePhone} mode={this.props.mode}
							onChanged={newVal => model.dynamicProperties.mobilePhone = newVal} />
					</Col>
					<Col sm={24}>
						<TextView label='Work phone'
							onGetErrorMessage={() => this.props.model.validate(false, 'workPhone')}
							value={model.dynamicProperties.workPhone} mode={this.props.mode}
							onChanged={newVal => model.dynamicProperties.workPhone = newVal} />
					</Col>
					<Col sm={24}>
						<TextView label='Home phone'
							onGetErrorMessage={() => this.props.model.validate(false, 'homePhone')}
							value={model.dynamicProperties.homePhone} mode={this.props.mode}
							onChanged={newVal => model.dynamicProperties.homePhone = newVal} />
					</Col>
					<Col sm={24}>
						<TextView label='Fax'
							onGetErrorMessage={() => this.props.model.validate(false, 'fax')}
							value={model.dynamicProperties.fax} mode={this.props.mode}
							onChanged={newVal => model.dynamicProperties.fax = newVal} />
					</Col>
				</Row>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/parts/client-contact.view.tsx